import {Injectable} from '@angular/core';
import {BaseApiService} from '../../../shared/base-service/base-api.service';

@Injectable()
export class FinanceService extends BaseApiService {

    /**
     * Gets the current user's profile
     * @returns A user profile model of type any
     */
    public getUserProfile() {
        return this.get('Foundation/User/Profile');
    }
}
